import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as Sentry from '@sentry/react'
import { withLDProvider } from 'launchdarkly-react-client-sdk'
import { ThemeProvider, Light } from '@runeffective/evo-design-system'

import '@blueprintjs/core/lib/css/blueprint.css'
import '@blueprintjs/datetime/lib/css/blueprint-datetime.css'
import '@blueprintjs/select/lib/css/blueprint-select.css'
import '@blueprintjs/popover2/lib/css/blueprint-popover2.css'
import './index.css'
import './blueprint_overrides/all.css'
import './blueprint_overrides/buttons.css'
import './blueprint_overrides/tooltip.css'
import './blueprint_overrides/menus.css'
import './blueprint_overrides/tabs.css'
import './blueprint_overrides/tags.css'
import './blueprint_overrides/checkbox.css'
import './blueprint_overrides/inputs.css'
import './blueprint_overrides/dialog.css'
import './blueprint_overrides/callout.css'
import './blueprint_overrides/cards.css'
import './blueprint_overrides/toast.css'
import './blueprint_overrides/datetime.css'
import './css/app.scss'
import './css/tailwind.build.css'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

const environment = window.location.hostname.includes('.spaceiq.com') ? 'production' : 'qa'
const isProd = environment === 'production'

if (process.env.REACT_APP_SENTRY_DSN) {
  const release = process.env.REACT_APP_SENTRY_RELEASE

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment,
    release,
  })
}

const rootElement = document.getElementById('root')
let ldClientSideId = null

if (isProd && process.env.REACT_APP_LD_CLIENT_ID) {
  ldClientSideId = process.env.REACT_APP_LD_CLIENT_ID
  console.log('Feature flags enabled')
} else if (process.env.REACT_APP_LD_CLIENT_ID_TEST) {
  ldClientSideId = process.env.REACT_APP_LD_CLIENT_ID_TEST
  console.log('Feature flags enabled for Test')
}

if (ldClientSideId) {
  const AppWithLD = withLDProvider({
    clientSideID: ldClientSideId,
    options: {},
  })(App)

  ReactDOM.render(
    <DndProvider {...{ backend: HTML5Backend }}>
      <ThemeProvider theme={Light}>
        <AppWithLD />
      </ThemeProvider>
    </DndProvider>,
    rootElement
  )
} else {
  ReactDOM.render(
    <DndProvider {...{ backend: HTML5Backend }}>
      <ThemeProvider theme={Light}>
        <App />
      </ThemeProvider>
    </DndProvider>,
    rootElement
  )
}
